import activatedCEModules from './activatedCEModules/store';
import app from './app/store';
import appearance from './appearance/store';
import client from './client/store';
import clientContext from './clientContext/store';
import navigation from './navigation/store';
import published from './published/store';
import quickLinks from './quickLinks/store';
import session from './session/store';
import pageVisibilities from './pageVisibilities/store';
import data from './data/store';
import authorisation from './authorisation/store';
import imageUploader from './imageUploader/store';
import features from './features/store';

const modules = {
  activatedCEModules,
  app,
  appearance,
  client,
  clientContext,
  navigation,
  published,
  quickLinks,
  session,
  pageVisibilities,
  data,
  authorisation,
  imageUploader,
  features
};

export default modules;
